import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { CustomTable, TableEmptyState } from '../../../../../components'
import { EnderecoList } from '../../../empresa/empresas-list/core/_models'
import { OrigemEndereco } from '../core/_origem'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { enderecosColumns } from './columns/_columns'

export const EnderecosTable = () => {
  const { isLoading, isError, refetch, responseSemPaginacao } = useQueryResponse()
  const { origem, id } = useParams<{ origem: string; id: string }>()

  const columns = useMemo(
    () => enderecosColumns(origem as OrigemEndereco, Number(id)),
    [origem, id]
  )

  return (
    <CustomTable<EnderecoList>
      id='kt_table_enderecos'
      ariaLabel='Endereços'
      itemLabel={{ singular: 'endereço', plural: 'endereços' }}
      data={responseSemPaginacao || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title='Nenhum endereço cadastrado'
          description='Use “Novo endereço” para cadastrar o primeiro endereço.'
        />
      }
      notPaginated
    />
  )
}
